import { IUserOrganisation } from 'APIPackage/AccountModule/interfaces/IUserOrganisation';
import { fetchProsecutorOrganisationsByErvkUuidAndVersion } from 'APIPackage/CatalogsModule/services/prosecutorOrganisationsApi';
import { IDistrict } from 'APIPackage/KnmModule/interfaces/IDistrict';
import { IProsecutorOffice } from 'APIPackage/KnmModule/interfaces/IProsecutorOffice';
import { createUserOrganizationWithDistrictSelectOption } from 'CorePackage/AccountModule/common/createUserOrganizationWithDistrictSelectOption';
import { createKnmProsecutorOrganisationSelectOption } from 'KnmPackage/MainModule/common/createKnmProsecutorOrganisationSelectOption';

export const getProsecutorOrganization = async (
  prosecutorOrganization: IProsecutorOffice | null,
  district: IDistrict | null,
) => {
  if (prosecutorOrganization?.ervkUuid && prosecutorOrganization?.ervkVersionUuid) {
    const ervkProsecutorOrganization: IUserOrganisation = await fetchProsecutorOrganisationsByErvkUuidAndVersion(
      prosecutorOrganization?.ervkUuid,
      prosecutorOrganization?.ervkVersionUuid,
    );

    return createUserOrganizationWithDistrictSelectOption(ervkProsecutorOrganization);
  }

  return prosecutorOrganization?.id && !prosecutorOrganization?.ervkUuid && prosecutorOrganization?.name
    ? createKnmProsecutorOrganisationSelectOption({
        prosecutorOrganization: {
          ...prosecutorOrganization,
          id: prosecutorOrganization.id,
          name: prosecutorOrganization?.name,
        },
        districtName: district?.name || null,
        districtId: district?.id?.toString() || null,
      })
    : undefined;
};
